import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://ltwoncmimlphtrmckbdy.supabase.co'
const supabaseKey = 'sb_publishable_ifDBPuGnvRCAXDcNSxfplw_v3VpFWXU'
export const supabase = createClient(supabaseUrl, supabaseKey)